import React, { Component } from "react";

import styled from "styled-components";
import SearchIcon from '@material-ui/icons/Search';
import { filterByParameter } from '../dashboard.filters';
import PreferenceDialogModal from '../../../modals/PreferenceDialogModal/PreferenceDialogModal';
import {
  ToggleSelect
  , InputText
  , MetricTileMultiple
  , mapMetricFromList
  , TableSortable
  , LabelString
  , ButtonMenu
} from '@loanbossinc/component-library';

const StyledWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const StyledHeaderDiv = styled.div`
  margin: .5em 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  span {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
  }
`;

const StyledSelect = styled(ToggleSelect)`
  && {
    margin-left: auto;
  }
`;

const SpacerDiv = styled.div`
    margin-top: 2em;
`;

const CustomizeDisplayDiv = styled.div`
 && {
   font-family: Work Sans;
   font-size: 14px;
   color: #005AA9;
   cursor:pointer;
 }
`;
const StyledButtonMenu = styled(ButtonMenu)`
  && {
    margin-left: .5em;
  }
`;

export class AssetDealMetric extends Component {
  state = {
    isModalOpen: false,
  }

  getMetrics = (metricData) => {
    const { searchText } = this.props;
    return filterByParameter(metricData, searchText, "title");
  }

  sortByTitleAlphabetically = (a, b) => {
    if (a.title < b.title) { return -1; }
    if (a.title > b.title) { return 1; }
    return 0;
  }

  metricTableCols = () => {
    return [
      {
        id: 'title'
        , label: 'Metric Name'
        , path: 'title'
        , Cell: (value) => <LabelString value={value} />
      }
      , {
        id: 'metricValue'
        , label: 'Metric Data'
        , path: 'metricValue'
        , Cell: (value) => <LabelString value={value} />
      }
    ]
  }

  closeModal = () => this.setState({ isModalOpen: false });
  openModal = () => this.setState({ isModalOpen: true });

  renderPreferenceModal = () => {
    const { screenPreferences, screenType, onModalSave } = this.props;
    const isOpen = this.state.isModalOpen;
    if (!isOpen) return null;
    return (
      <PreferenceDialogModal
        isMetric={true}
        screenType={screenType}
        onClose={this.closeModal}
        isOpen={this.state.isModalOpen}
        prefData={screenPreferences}
        maxCount={6}
        onSaveCallback={onModalSave}
      />
    );
  }

  render() {
    const {
      title
      , onSearchChange
      , searchText
      , menuOptions
      , screenPreferences
      , guestPermissions
      , metricData
      , childDealsFilter
    } = this.props;

    const screenPrefsWithMetrics = [];

    if (screenPreferences) {
      screenPreferences.forEach((currentScreenItem) => {
        screenPrefsWithMetrics.push({
          title: currentScreenItem.title, metricValue: mapMetricFromList(currentScreenItem.screenElementId, metricData),
          layoutOrder: currentScreenItem.layoutOrder, isSelected: currentScreenItem.isSelected,
        })
      });
    }

    const isGuest = (guestPermissions && guestPermissions.isGuest && !guestPermissions.hasRestrictedMetricPermission && !guestPermissions.hasFullMetricPermission);
    const selectedMetrics = isGuest ? [] : screenPrefsWithMetrics.filter(x => x.isSelected).sort((a, b) => (a.layoutOrder - b.layoutOrder));
    const unSelectedMetrics = isGuest ? [] : screenPrefsWithMetrics.filter(x => !x.isSelected).sort(this.sortByTitleAlphabetically);

    return (

      <StyledWrapper>
        {this.renderPreferenceModal()}
        {childDealsFilter}
        <StyledHeaderDiv>
          <div>
            <span>{title}</span>
            <CustomizeDisplayDiv onClick={() => this.openModal()}>
              Customize display
            </CustomizeDisplayDiv>
          </div>
          {menuOptions && <StyledButtonMenu hasBorder iconName='more_horiz' options={menuOptions} />}
        </StyledHeaderDiv>


        <div>
          <MetricTileMultiple options={selectedMetrics}></MetricTileMultiple>
        </div>
        <SpacerDiv />

        <InputText
          type="search"
          variant="outlined"
          placeholder="Search for a metric"
          onChange={onSearchChange}
          value={searchText}
          InputProps={{
            startAdornment: <SearchIcon />
          }}
        />

        <SpacerDiv />
        <div>
          <TableSortable
            columns={this.metricTableCols()}
            items={this.getMetrics(unSelectedMetrics)} />
        </div>
      </StyledWrapper >
    );
  }
}
